/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react'
// eslint-disable-next-line import/no-unresolved
import { BeatLoader } from 'react-spinners'
import Icon from '../../../../components/icon'
import {
  Actions,
  ButtonFilters,
  DownloadButton,
  DropdownContainer,
  FilterButton,
  FilterTitle,
  Filters,
  LabelCheckbox,
  PeriodFilter,
  SpanCheckbox,
} from './styles'
import { theme } from '../../../../styles/theme'
import DatePicker from '../../../../components/date-picker/date-picker'
import { If } from '../../../../components/if/if'

interface CheckboxProps {
  item: any;
  isChecked: boolean;
  onSelect: (label: string) => void;
}

const Checkbox: React.FC<CheckboxProps> = ({ item, isChecked, onSelect }) => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <LabelCheckbox>
      <input
        type="checkbox"
        checked={isChecked}
        onChange={() => onSelect(item)}
      />
      <SpanCheckbox
        style={{ fontWeight: isChecked ? '600' : 'normal' }}
      >
        {item.name}
      </SpanCheckbox>
    </LabelCheckbox>
  </div>
)

export const FiltersGroup = ({
  presetPeriods,
  selectedPeriod,
  onSelectPeriod,
  onSelectPaymentMethod,
  selectedPaymentMethod,
  paymentMethods,
  onFrom,
  onTo,
  hasCustomPeriod,
  onToggleCustomPeriod,
  onDownload,
  loadingDownload,
  onApplyFilter,
  to,
  from,
}: any) => {
  const [filterDropdownIsOpen, setFilterDropdownIsOpen] = useState(false)

  const handleToggleDropdown = () => {
    setFilterDropdownIsOpen((state) => !state)
  }

  const handleApply = () => {
    onApplyFilter()
    setFilterDropdownIsOpen(false)
  }

  return (
    <Actions>
      <PeriodFilter>
        {
        presetPeriods.map((period: any) => (
          <button
            key={period.id}
            onClick={() => onSelectPeriod(period)}
            type="button"
            style={{
              color: selectedPeriod?.id === period.id ? theme.colors.blackLight : '#E4E4E4',
              borderColor: selectedPeriod?.id === period.id ? theme.colors.orange : '#E4E4E4',
            }}
          >
            {period.label}
          </button>
        ))
      }
      </PeriodFilter>

      <Filters>
        <ButtonFilters onClick={handleToggleDropdown}>
          <Icon name="adjustment" />
        </ButtonFilters>

        {
        filterDropdownIsOpen && (
          <DropdownContainer>
            Filtrar por:

            <hr />

            <div style={{ display: 'flex', gap: '15px', flexDirection: 'column' }}>
              <FilterTitle>Forma de pagamento</FilterTitle>
              {
                paymentMethods.map((paymentMethod: any) => (
                  <Checkbox
                    item={paymentMethod}
                    onSelect={onSelectPaymentMethod}
                    isChecked={paymentMethod.value === selectedPaymentMethod}
                  />
                ))
              }
            </div>

            <hr />

            <Checkbox
              item={{ name: 'Data personalizada' }}
              onSelect={onToggleCustomPeriod}
              isChecked={hasCustomPeriod}
            />

            <DatePicker
              disabled={!hasCustomPeriod}
              onFrom={onFrom}
              onTo={onTo}
              from={from}
              to={to}
            />

            <FilterButton onClick={handleApply}>Aplicar filtro</FilterButton>

          </DropdownContainer>
        )
      }
      </Filters>

      <DownloadButton onClick={onDownload} disabled={loadingDownload}>
        <If condition={!loadingDownload}>
          <Icon name="download_grey" />
          Download
        </If>
        <If condition={loadingDownload}>
          <BeatLoader color={theme.colors.orange} />
        </If>
      </DownloadButton>
    </Actions>
  )
}
